import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Booking from "./pages/Booking";
import PlanTrip from "./pages/PlanTrip";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Account from "./pages/Account";
import Admin from "./pages/Admin";
import AuthCallback from "./pages/AuthCallback";
import { Toaster } from "@/components/ui/sonner";
import { FloatingDock } from "@/components/FloatingDock";
import { IntroSplash } from "@/components/IntroSplash";
import { AuthProvider } from "@/context/AuthContext";

function AppRoutes() {
  const location = useLocation();
  // CRITICAL: handle Emergent OAuth redirect with #session_id synchronously
  // before any other route renders, to avoid race conditions.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/booking" element={<Booking />} />
      <Route path="/plan-trip" element={<PlanTrip />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/account" element={<Account />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppRoutes />
        <IntroSplash />
        <FloatingDock />
        <Toaster />
      </AuthProvider>
    </Router>
  );
}

export default App;
